import {Form, Modal, Spin} from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import AddEmail from "../../Common/components/AddEmail"
import { transactionLaneDataHandle } from "../state/actions";
// import { AddEmailModal } from "./AddEmailModal";
// import AddEmailModal from "../../PropertyComp/components/AddEmailModal";
// import { PropertyHandlers } from "../../PropertyComp/state/actions";

const AddEmailModalRtd = ({ modalVisible, setModalVisible,combinedClients, selectedData, seller, filterSort, source, rtdData, delegateSide, componentUsedSection,offerId,propertyId, setShowModal, userAuthKey, rootDocData, setCallPropertyDocsApi }) => {
  const dispatch = useDispatch();
  const { offerTablePropertyId } = useSelector((state) => state.offerTable);
  const { propertDocsLoading} = useSelector((state) => state.rtdTransactionLane);
  const [form] = Form.useForm()
  const [enterEmailModal, setEnterEmailModal] = useState({
    visible: false,
    data: {},
    inValid: false,
  });
  const [clickedDataEmail, setClickedDataEmail] = useState({});

  const isSmallScreen = useMediaQuery({ maxWidth: 550 });
  const isMediumScreen = useMediaQuery({ minWidth: 551, maxWidth: 850 });

  const successFunc = ({reducerFunc}) => {
    if(componentUsedSection === "TRANSACTION_DASHBOARD"){
      if(reducerFunc){
        dispatch(reducerFunc());
      }
    }
    else{
    //   dispatch(PropertyHandlers.changeFilterSort({...filterSort}));
    }
  }

  const handleAddEmail = (values, check) => {
    // let documentId = rootDocData?.documentId;
    let data;
    if (!enterEmailModal?.inValid) {
      data = {
        addToProperty: false,
        offerId: selectedData?.offerId,
        sellerDetail: {
          fullName: clickedDataEmail?.personId?.fullName ? clickedDataEmail?.personId?.fullName : clickedDataEmail?.fullName,
          ...(clickedDataEmail?.personId?._id
            ? {
                personId: clickedDataEmail?.personId?._id,
              }
            : {
                key: clickedDataEmail?.key ? clickedDataEmail?.key : clickedDataEmail?._id,
                isCorp: clickedDataEmail?.isCorp,
                corpKey: clickedDataEmail.corpKey,
              }),
          ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
        },
        openFor: "SELLER_AGENT",
        ...(values?._id ? { selectedId: values?._id } : {}),
        ...(check ? { newClient: true } : {}),
      };
      dispatch(transactionLaneDataHandle.addEmailFun({ data, userAuthKey, source, setEnterEmailModal, enterEmailModal, setIsEmailModalVisible: setModalVisible, isEmailModalVisible: modalVisible, setCallPropertyDocsApi, form }));
    } else {
      data = {
        ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
      };
      dispatch(transactionLaneDataHandle.updateEmail(data, clickedDataEmail?.personId?._id, userAuthKey, offerTablePropertyId, source));
    }
    setEnterEmailModal({ ...enterEmailModal, visible: false });
  };

  return (
    <>

      {enterEmailModal && <AddEmail enterEmailModal={enterEmailModal} setEnterEmailModal={setEnterEmailModal} form={form} handleAddEmail={handleAddEmail} clickedDataEmail={clickedDataEmail} role={"Seller"} selectedData={selectedData} userAuthKey={userAuthKey} source={source} offerId={offerId} rootDocData={rootDocData} setCallPropertyDocsApi={setCallPropertyDocsApi} />}

      <Modal visible={modalVisible.isAllEmailsModalOpen} width={"950px"} 
      onCancel={() => {
      setModalVisible({ ...modalVisible, isAllEmailsModalOpen: false })
      setShowModal(false)
      }}
       footer={false} title={<p style={{ textAlign: "center", color: "#178DFA", fontSize: "22px", fontWeight: "bold" }}>Add Email</p>}>
        <>
          {propertDocsLoading ? <Spin size="large" style={{margin:"15% 0 15% 50%"}}/> : 
          <div style={{ overflowX: "auto", paddingBottom: "20px", marginBottom: "10px" }}>
            {seller === "BUYER"
              ? (source === "RTD" ? rtdData?.buyerIds : combinedClients)?.map((buyer) => (
                  <div key={buyer._id} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                    {!buyer.isCorp ? (
                      <div>
                        <span style={{ fontSize: "20px", cursor: "context-menu" }}>{buyer.fullName}</span>
                        <span style={{ fontSize: "25px", fontWeight: "bold", cursor: "context-menu", marginRight: "5px" }}> - </span>{" "}
                        {buyer.personId?.email ? (
                          <span style={{ fontSize: "20px", color: "blue", cursor: "context-menu", textDecoration: "underline" }}>{buyer.personId.email}</span>
                        ) : (
                          <AddEmail offerId={selectedData?.offerId} clientData={buyer} successFunc={successFunc} role={seller} delegate={delegateSide && true} selectedData={selectedData} setModalVisible={setModalVisible}  setShowModal={ setShowModal}/>
                        )}
                      </div>
                    ) : (
                      <div>
                        <span style={{ fontSize: "20px", color: "orange" }}>
                          {buyer?.fullName || ""} {"Signers"}
                        </span>
                        {buyer?.signers?.map((ele) => (
                          <div style={{ marginLeft: "20px", display: "flex", alignItems: "center", whiteSpace: "nowrap", fontSize: "18px" }} key={ele?._id}>
                            <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
                              <span style={{ fontSize: "20px", cursor: "context-menu" }}>{ele?.fullName}</span>
                              <span style={{ fontSize: "25px", fontWeight: "bold", cursor: "context-menu", marginLeft: "5px", marginRight: "5px" }}>-</span>
                              <span style={{ fontSize: "20px", color: "blue", textDecoration: "underline" }}>
                                {ele.personId?.email ? (
                                  <span style={{ fontSize: "20px", color: "blue", cursor: "context-menu", textDecoration: "underline" }}>{ele.personId.email}</span>
                                ) : (
                                  <AddEmail offerId={selectedData?.offerId} clientData={{...ele,isCorp:true}} successFunc={successFunc} role={seller} delegate={delegateSide && true} selectedData={selectedData} setModalVisible={setModalVisible} isModalVisible={modalVisible} setShowModal={ setShowModal}/>
                                )}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              : (source === "RTD" ? rtdData?.sellerIds : combinedClients)?.map((seller) => (
                  <div key={seller._id} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                    {!seller.isCorp ? (
                      <div>
                        <span style={{ fontSize: "20px", cursor: "context-menu" }}>{seller?.fullName}</span>
                        <span style={{ fontSize: "25px", fontWeight: "bold", cursor: "context-menu", marginRight: "5px" }}> - </span>{" "}
                        {seller?.personId?.email ? (
                          <span style={{ fontSize: "20px", color: "blue", cursor: "context-menu", textDecoration: "underline" }}>{seller?.personId?.email}</span>
                        ) : (
                          // <AddEmail offerId={offerId} clientData={seller} successFunc={successFunc} role={seller} delegate={delegateSide && true} selectedData={selectedData} setModalVisible={setModalVisible} isModaVisible={modalVisible} setShowModal={ setShowModal}/>
                          <button
                          onClick={() => {
                            setClickedDataEmail(seller);
                            setEnterEmailModal({ ...enterEmailModal, visible: true });
                          }}
                          style={{ fontSize: isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px", backgroundColor: "#1890ff", color: "white", border: "none", borderRadius: "2px", cursor: "pointer" }}
                        >
                          Add Email
                        </button>
                        )}
                      </div>
                    ) : (
                      <div>
                        <span style={{ fontSize: "20px" ,color: "orange"}}>
                          {seller?.fullName || ""} {"Signers"}
                        </span>
                        {seller?.signers?.map((ele) => (
                          <div style={{ marginLeft: "20px", display: "flex", alignItems: "center", whiteSpace: "nowrap", fontSize: "18px" }} key={ele?._id}>
                            <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
                              <span style={{ fontSize: "20px", cursor: "context-menu" }}>{ele?.fullName}</span>
                              <span style={{ fontSize: "25px", fontWeight: "bold", cursor: "context-menu", marginLeft: "5px", marginRight: "5px" }}>-</span>
                              <span style={{ fontSize: "20px", color: "blue", textDecoration: "underline" }}>
                                {ele?.personId?.email ? (
                                  <span style={{ fontSize: "20px", color: "blue", cursor: "context-menu", textDecoration: "underline" }}>{ele?.personId?.email}</span>
                                ) : (
                                  // <AddEmail offerId={offerId} clientData={{...ele,isCorp:true}} successFunc={successFunc} role={seller} delegate={delegateSide && true} selectedData={selectedData} setModalVisible={setModalVisible} setShowModal={ setShowModal}/>
                                  <button
                                    onClick={() => {
                                      setClickedDataEmail({...ele,corpKey: seller?.key, isCorp: true});
                                      setEnterEmailModal({ ...enterEmailModal, visible: true });
                                    }}
                                    style={{ fontSize: isSmallScreen ? "10px" : isMediumScreen ? "12px" : "14px", backgroundColor: "#1890ff", color: "white", border: "none", borderRadius: "2px", cursor: "pointer" }}
                                  >
                                    Add Email
                                  </button>
                                )}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
          </div>}
        </>
      </Modal>
    </>
  );
};

export { AddEmailModalRtd };